import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Agenda() {
  const [selectedCategory, setSelectedCategory] = useState('todos');

  const events = [
    {
      id: 1,
      title: 'Aula Inaugural - Programa Despertar',
      date: '15 de Março, 2024',
      time: '19:00 - 21:00',
      location: 'Presencial - Sede São Paulo',
      category: 'aula-inaugural',
      description: 'Conheça o programa Despertar e dê o primeiro passo na sua jornada de autoconhecimento.',
      spots: 30,
      image: 'https://public.readdy.ai/ai/img_res/faf5f6ef1fb709e3e1c110d24c0d5a36.jpg'
    },
    {
      id: 2,
      title: 'Workshop: Inteligência Emocional no Trabalho',
      date: '20 de Março, 2024',
      time: '14:00 - 17:00',
      location: 'Online - Zoom',
      category: 'workshop',
      description: 'Aprenda a gerenciar suas emoções e melhorar suas relações profissionais.',
      spots: 50,
      image: 'https://readdy.ai/api/search-image?query=professional%20workshop%20emotional%20intelligence%20training%20session%20modern%20conference%20room%20engaged%20participants%20natural%20lighting%20collaborative%20learning%20environment%20professional%20photography&width=800&height=500&seq=event2&orientation=landscape'
    },
    {
      id: 3,
      title: 'Encontro Presencial - Geração Valor',
      date: '25 de Março, 2024',
      time: '09:00 - 17:00',
      location: 'Presencial - Sede São Paulo',
      category: 'encontro',
      description: 'Dia completo de atividades, networking e desenvolvimento para jovens líderes.',
      spots: 40,
      image: 'https://readdy.ai/api/search-image?query=youth%20leadership%20gathering%20young%20people%20networking%20event%20modern%20bright%20venue%20collaborative%20activities%20natural%20lighting%20energetic%20atmosphere%20professional%20photography%20diverse%20group&width=800&height=500&seq=event3&orientation=landscape'
    },
    {
      id: 4,
      title: 'Palestra: Como Construir uma Carreira de Sucesso',
      date: '28 de Março, 2024',
      time: '19:30 - 21:00',
      location: 'Online - YouTube Live',
      category: 'palestra',
      description: 'Especialistas compartilham estratégias para crescimento profissional.',
      spots: 100,
      image: 'https://readdy.ai/api/search-image?query=professional%20speaker%20career%20success%20lecture%20modern%20auditorium%20engaged%20audience%20natural%20lighting%20inspiring%20presentation%20professional%20photography%20motivational%20event&width=800&height=500&seq=event4&orientation=landscape'
    },
    {
      id: 5,
      title: 'Aula Aberta - Marketing Digital',
      date: '5 de Abril, 2024',
      time: '19:00 - 21:00',
      location: 'Presencial - Sede São Paulo',
      category: 'aula-aberta',
      description: 'Experimente gratuitamente uma aula do curso de Marketing Digital.',
      spots: 25,
      image: 'https://readdy.ai/api/search-image?query=digital%20marketing%20class%20students%20learning%20modern%20classroom%20computers%20screens%20natural%20lighting%20engaged%20learners%20professional%20photography%20educational%20environment&width=800&height=500&seq=event5&orientation=landscape'
    },
    {
      id: 6,
      title: 'Workshop: Preparação para Entrevistas',
      date: '10 de Abril, 2024',
      time: '14:00 - 16:00',
      location: 'Online - Zoom',
      category: 'workshop',
      description: 'Técnicas e dicas para se destacar em processos seletivos.',
      spots: 40,
      image: 'https://readdy.ai/api/search-image?query=job%20interview%20preparation%20workshop%20professional%20training%20session%20modern%20office%20setting%20natural%20lighting%20engaged%20participants%20professional%20photography%20career%20development&width=800&height=500&seq=event6&orientation=landscape'
    },
    {
      id: 7,
      title: 'Encontro de Mentoria em Grupo',
      date: '15 de Abril, 2024',
      time: '10:00 - 12:00',
      location: 'Presencial - Sede São Paulo',
      category: 'mentoria',
      description: 'Sessão de mentoria coletiva com profissionais experientes.',
      spots: 20,
      image: 'https://readdy.ai/api/search-image?query=group%20mentoring%20session%20mentor%20with%20mentees%20modern%20bright%20meeting%20room%20collaborative%20discussion%20natural%20lighting%20professional%20photography%20supportive%20environment&width=800&height=500&seq=event7&orientation=landscape'
    },
    {
      id: 8,
      title: 'Programa de Liderança - Módulo Intensivo',
      date: '20 de Abril, 2024',
      time: '09:00 - 18:00',
      location: 'Presencial - Sede São Paulo',
      category: 'programa',
      description: 'Dia intensivo de desenvolvimento de habilidades de liderança.',
      spots: 30,
      image: 'https://readdy.ai/api/search-image?query=leadership%20training%20intensive%20program%20group%20activities%20modern%20training%20facility%20natural%20lighting%20engaged%20participants%20professional%20photography%20team%20building&width=800&height=500&seq=event8&orientation=landscape'
    }
  ];

  const categories = [
    { id: 'todos', name: 'Todos os Eventos', icon: 'ri-calendar-line' },
    { id: 'aula-inaugural', name: 'Aulas Inaugurais', icon: 'ri-door-open-line' },
    { id: 'workshop', name: 'Workshops', icon: 'ri-tools-line' },
    { id: 'aula-aberta', name: 'Aulas Abertas', icon: 'ri-book-open-line' },
    { id: 'encontro', name: 'Encontros', icon: 'ri-group-line' },
    { id: 'palestra', name: 'Palestras', icon: 'ri-presentation-line' },
    { id: 'mentoria', name: 'Mentorias', icon: 'ri-user-star-line' },
    { id: 'programa', name: 'Programas', icon: 'ri-trophy-line' }
  ];

  const filteredEvents = selectedCategory === 'todos' 
    ? events 
    : events.filter(event => event.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-blue-600 via-purple-600 to-blue-700">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-yellow-400 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-400 rounded-full blur-3xl"></div>
        </div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Agenda de Eventos
            </h1>
            <p className="text-xl text-white/90 leading-relaxed">
              Participe de aulas abertas, workshops e encontros transformadores
            </p>
          </div>
        </div>
      </section>

      {/* Categories Filter */}
      <section className="py-12 bg-white border-b border-slate-100 sticky top-20 z-40">
        <div className="container mx-auto px-6">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`flex items-center gap-2 px-6 py-3 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  selectedCategory === category.id
                    ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg'
                    : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
                }`}
              >
                <i className={`${category.icon} text-lg`}></i>
                <span>{category.name}</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Events Grid */}
      <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
        <div className="container mx-auto px-6">
          {filteredEvents.length === 0 ? (
            <div className="text-center py-20">
              <i className="ri-calendar-close-line text-6xl text-slate-300 mb-4"></i>
              <p className="text-xl text-slate-600">Nenhum evento encontrado nesta categoria</p>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 gap-8">
              {filteredEvents.map((event) => (
                <div key={event.id} className="bg-white rounded-2xl shadow-lg overflow-hidden border border-slate-100 hover:shadow-2xl transition-all">
                  <div className="relative h-64">
                    <img
                      src={event.image}
                      alt={event.title}
                      className="w-full h-full object-cover object-top"
                    />
                    <div className="absolute top-4 right-4 bg-white px-4 py-2 rounded-full shadow-lg">
                      <p className="text-sm font-semibold text-slate-900 flex items-center gap-2">
                        <i className="ri-user-line text-blue-600"></i>
                        {event.spots} vagas
                      </p>
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-2xl font-bold text-slate-900 mb-4">{event.title}</h3>
                    <p className="text-slate-700 mb-6 leading-relaxed">{event.description}</p>
                    <div className="space-y-3 mb-6">
                      <div className="flex items-center gap-3 text-slate-600">
                        <i className="ri-calendar-line text-xl text-blue-600"></i>
                        <span>{event.date}</span>
                      </div>
                      <div className="flex items-center gap-3 text-slate-600">
                        <i className="ri-time-line text-xl text-blue-600"></i>
                        <span>{event.time}</span>
                      </div>
                      <div className="flex items-center gap-3 text-slate-600">
                        <i className="ri-map-pin-line text-xl text-blue-600"></i>
                        <span>{event.location}</span>
                      </div>
                    </div>
                    <button className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-4 rounded-full font-semibold hover:from-blue-700 hover:to-purple-700 transition-all shadow-lg whitespace-nowrap cursor-pointer">
                      Inscrever-se no Evento
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Info Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-blue-50 to-purple-50 p-8 rounded-2xl border border-blue-100">
              <h2 className="text-3xl font-bold text-slate-900 mb-6 text-center">
                Informações Importantes
              </h2>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-information-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 mb-2">Inscrições Gratuitas</h4>
                    <p className="text-slate-700">Todos os eventos são gratuitos para alunos e comunidade</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-purple-600 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-medal-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 mb-2">Certificado de Participação</h4>
                    <p className="text-slate-700">Receba certificado digital ao participar dos eventos</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-yellow-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-group-line text-2xl text-slate-900"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 mb-2">Networking</h4>
                    <p className="text-slate-700">Conecte-se com outros participantes e profissionais</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-gift-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 mb-2">Material Exclusivo</h4>
                    <p className="text-slate-700">Receba materiais e recursos complementares</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-blue-600 via-purple-600 to-blue-700 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-yellow-400 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-400 rounded-full blur-3xl"></div>
        </div>
        <div className="container mx-auto px-6 text-center relative z-10">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Não perca nenhum evento!
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Inscreva-se em nossos programas e receba notificações sobre todos os eventos e oportunidades.
          </p>
          <a
            href="https://wa.me/5511999999999"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-yellow-400 text-slate-900 px-10 py-5 rounded-full font-bold text-lg hover:bg-yellow-500 transition-all shadow-2xl hover:shadow-yellow-400/50 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line mr-2"></i>
            Falar no WhatsApp
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
